export const parseQueryParamValue = (value: string) => {
  return value === 'true' ? true : value === 'false' ? false : value
}
